// @flow

import React from 'react'
import { StoreProvider } from 'easy-peasy'

import { store } from '../../store'

import { WizardsList } from './WizardsList'

export default function WizardsListPage () {
  return (
    <StoreProvider store={store}>
      <WizardsList/>
    </StoreProvider>
  )
}
